import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/Layout.vue";
import { getToken } from "../utils/storage";
import { defaultHomePath } from "../utils/defaultHome";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/h5",
    component: () => import("../layout/H5Layout.vue"),
    redirect: "/h5/home",
    children: [
      {
        path: "home",
        name: "h5-home",
        component: () => import("../views/h5/HomePage.vue"),
        meta: { title: "首页" }
      },
      {
        path: "mp-pay-orders",
        name: "h5-mp-pay-orders",
        component: () => import("../views/h5/MpPayOrdersPage.vue"),
        meta: { title: "订单管理" }
      },
      {
        path: "onboardings",
        name: "h5-onboardings",
        component: () => import("../views/h5/OnboardingListPage.vue"),
        meta: { title: "特约商户进件" }
      },
      {
        path: "onboardings/new",
        redirect: (to) => ({
          name: "h5-onboardings",
          query:
            typeof to.query !== "undefined" && to.query && to.query.id
              ? { create: "1", cid: String(to.query.id) }
              : { create: "1" }
        })
      },
      {
        path: "onboardings/:id",
        name: "h5-onboarding-detail",
        component: () => import("../views/h5/OnboardingDetailPage.vue"),
        meta: { title: "进件详情" }
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../views/dashboard/Index.vue"),
        meta: { title: "首页" }
      },
      {
        path: "users",
        name: "users",
        component: () => import("../views/user/Index.vue"),
        meta: { title: "用户管理" }
      },
      {
        path: "departments",
        name: "departments",
        component: () => import("../views/department/Index.vue"),
        meta: { title: "部门管理" }
      },
      {
        path: "menus",
        name: "menus",
        component: () => import("../views/menu/Index.vue"),
        meta: { title: "菜单管理" }
      },
      {
        path: "permissions",
        name: "permissions",
        component: () => import("../views/permission/Index.vue"),
        meta: { title: "权限管理" }
      },
      {
        path: "wechat/pay-configs",
        name: "wechat-pay-configs",
        component: () => import("../views/wechat/pay-configs/Index.vue"),
        meta: { title: "微信支付配置" }
      },
      {
        path: "wechat/onboardings",
        name: "wechat-onboardings",
        component: () => import("../views/wechat/onboardings/Index.vue"),
        meta: { title: "特约商户进件" }
      },
      {
        path: "wechat/mp-pay-orders",
        name: "wechat-mp-pay-orders",
        component: () => import("../views/wechat/mp-pay-orders/Index.vue"),
        meta: { title: "小程序支付订单" }
      },
      {
        path: "apifactory",
        name: "apifactory",
        component: () => import("../views/apifactory/Index.vue"),
        meta: { title: "API工厂" }
      },
      {
        path: "apifactory/table-query",
        name: "apifactory-table-query",
        component: () => import("../views/apifactory/table-query/Index.vue"),
        meta: { title: "卓号查询" }
      },
      {
        path: "logs/operation",
        name: "logs-operation",
        component: () => import("../views/logs/OperationLog.vue"),
        meta: { title: "操作日志" }
      },
      {
        path: "logs/api-calls",
        name: "logs-api-calls",
        component: () => import("../views/logs/ApiCallLog.vue"),
        meta: { title: "接口调用日志" }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
    return;
  }
  if (!getToken()) {
    next("/login");
    return;
  }
  if (
    (to.path === "/dashboard" || to.name === "dashboard") &&
    defaultHomePath() === "/h5/home"
  ) {
    next({ path: "/h5/home", replace: true });
    return;
  }
  next();
});

router.afterEach((to) => {
  const isH5 = typeof to.path === "string" && to.path.startsWith("/h5");
  document.body.classList.toggle("h5-ui-skin", isH5);
});

export default router;
